module.exports = __webpack_public_path__ + "img/ruku-h.dc125f6c.svg";